import React from 'react'
import { IconProps } from '../../types/types'

const DesktopIcon: React.FC<IconProps> = ({ width = '16', height = '13', color = '#003366' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.29203 1.33203H11.6987C14.072 1.33203 14.6654 1.92536 14.6654 4.29203V8.51203C14.6654 10.8854 14.072 11.472 11.7054 11.472H4.29203C1.92536 11.4787 1.33203 10.8854 1.33203 8.5187V4.29203C1.33203 1.92536 1.92536 1.33203 4.29203 1.33203Z" stroke={color} stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M1.33203 8.66797H14.6654" stroke={color} stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  )
}

export default DesktopIcon